import script from "./ProductCategory.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductCategory.vue?vue&type=script&setup=true&lang=ts"

import "./ProductCategory.vue?vue&type=style&index=0&id=1334db5a&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1334db5a"]])

export default __exports__